import { IComponentOptions } from "angular";
import { ProcessTemplateEditController } from "./controller";
export const vsComponentName = "processTemplateEdit";
export const ProcessTemplateEditComponentOptions: IComponentOptions =
{
  controller: ProcessTemplateEditController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    template: "<",
  },
};
